/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-statements */
import { useCallback } from "react";
import jwtDecode from "jwt-decode";
import { desktopCleverTapEvent, trackDesktopCustomEventsAU } from "../tracking/index";
import { USER_LOGIN_STATUS } from "../constants/app-constants";
import parseCookie from "../utils/helpers/parse-cookie";

import { getHashedDetails } from "../utils/helpers/get-sha256-hash";
import { AUTH_ADDRESS } from "../constants/api-constants";
import { AU_DESKTOP_EVENTS } from "../tracking/au.desktop-events";
const loginEvent = {
    [AUTH_ADDRESS.GOOGLE]: {
        name: "google",
        succesEvent: {eventName: "LOGIN_SUCCESSFULL_GOOGLE"},
        clevetTap: {eventName: "Google"},
        extraGAEvents: "LOGIN_SUCCESS_GOOGLE"
    },
    [AUTH_ADDRESS.FACEBOOK]: {
        name: "facebook",
        succesEvent: {eventName: "LOGIN_SUCCESSFULL_FACEBOOK"},
        clevetTap: {eventName: "Facebook"},
        extraGAEvents: "LOGIN_SUCCESS_FACEBOOK"
    },
    [AUTH_ADDRESS.APPLE]: {
        name: "apple",
        succesEvent: {eventName: "LOGIN_SUCCESSFULL_APPLE"},
        clevetTap: {eventName: "Apple"},
        extraGAEvents: "LOGIN_SUCCESS_APPLE"
    }
};

const useThirdPartySignIn = ({ onLoginSuccessCallback, clearCallbacksAndClose, setRecentlyViewedDataConnect, fetchSearchResultConnect }) => {
    const handleThirdPartySignIn = useCallback(async (cbResponse, type) => {
        try {
            const { succesEvent, clevetTap, extraGAEvents, name } = loginEvent[type] || {};

            // Track events
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS[succesEvent.eventName]);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SIGNIN, {
                user_id: cbResponse.username,
                user_status: USER_LOGIN_STATUS.LOGGED_IN,
                login_type: name
            });

            // Track CleverTap events
            desktopCleverTapEvent("SIGNUP", {
                Mode_of_lead: clevetTap.eventName,
                signup_amplitudeId: parseCookie("amp_amplit"),
                signup_gaid: parseCookie("_ga")
            }, { userAgent: true });

            // Track additional GA events
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS[extraGAEvents], { au_email: cbResponse.username });

            // Call success callback
            onLoginSuccessCallback(cbResponse);

            // Handle token and user details
            const { access_token: token = "" } = cbResponse || {};
            const { mobilePhone = "" } = jwtDecode(token || "") || {};
            const { email: hashedEmail = null, mobile: hashedMobile = null } = await getHashedDetails({
                email: cbResponse.username,
                mobile: mobilePhone || ""
            });

            // Track login success and method
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_SUCCESS, {
                eventLabel: type.toLowerCase(),
                au_hashed_email: hashedEmail || null,
                au_hashed_phone_number: hashedMobile || null
            });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_METHOD, { eventLabel: type.toLowerCase() });

            // Update recently viewed and cleanup
            setRecentlyViewedDataConnect(token);
            fetchSearchResultConnect();

        } catch (error) {
            throw error;
        }
    }, [onLoginSuccessCallback, clearCallbacksAndClose]);

    return { handleThirdPartySignIn };
};

export default useThirdPartySignIn;
